import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

function PauseIcon({
  color,
  ...svgProps
}) {
  return /*#__PURE__*/jsxs(SVG, {
    ref: svgProps.ref,
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 18),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("rect", {
      width: "4.5",
      height: "16.5",
      x: ".75",
      y: ".75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("rect", {
      width: "4.5",
      height: "16.5",
      x: "9.75",
      y: ".75",
      rx: "1.5"
    })]
  });
}

export { PauseIcon };
//# sourceMappingURL=pause.js.map
